
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"procesarCertificacionTraspaso"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fechaProcesado"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"observacionProcesado"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"procesarCertificacionTraspaso"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"fechaProcesado"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fechaProcesado"}}},{"kind":"Argument","name":{"kind":"Name","value":"observacionProcesado"},"value":{"kind":"Variable","name":{"kind":"Name","value":"observacionProcesado"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"traspaso"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numero"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"estado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reemplazante"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apellido"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organismo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"origen"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"destino"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fechaDesde"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaHasta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"normativa"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pagoViaticos"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"observacionCarga"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"observacionVisado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"observacionProcesado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"usuarioCreador"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fechaCreacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"resolucion"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"archivoId"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":733}};
    doc.loc.source = {"body":"mutation procesarCertificacionTraspaso(\n  $_id: String\n  $fechaProcesado: Date\n  $observacionProcesado: String\n) {\n  procesarCertificacionTraspaso(\n    _id: $_id\n    fechaProcesado: $fechaProcesado\n    observacionProcesado: $observacionProcesado\n  ) {\n    _id\n    traspaso {\n      _id\n      numero\n    }\n    estado\n    reemplazante {\n      username\n      nombre\n      apellido\n      organismo {\n        nombre\n      }\n    }\n    origen {\n      nombre\n    }\n    destino {\n      nombre\n    }\n    fechaDesde\n    fechaHasta\n    normativa\n    pagoViaticos\n    observacionCarga\n    observacionVisado\n    observacionProcesado\n    usuarioCreador {\n      username\n    }\n    fechaCreacion\n    resolucion {\n      _id\n      archivoId\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["procesarCertificacionTraspaso"] = oneQuery(doc, "procesarCertificacionTraspaso");
        
